import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const WhySection = ({ quoteUrl, capabilitiesUrl, showQuoteButton }) => {
	return (
		<Box className="main why-container">
			<Box className="container">
				<Typography className="sub-heading" component="span">
					{translator.translate('sandhills.printpromo.whychoose') || 'WHY CHOOSE SANDHILLS?'}
				</Typography>
				<Typography component="h2" variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
					Backed By Experience. Built For Reliability.
				</Typography>
				<Typography component="p" sx={{ lineHeight: 1.65 }}>
					Sandhills Global Print &amp; Promo is supported by the resources, processes, and standards of Sandhills Global &#8212; giving you confidence that your project will be handled professionally from start to finish.
				</Typography>
				<Box className="btn-container">
					{showQuoteButton && quoteUrl ? (
						<a href={quoteUrl} className="btn">Request Pricing For Your Project</a>
					) : (
						capabilitiesUrl && (
							<a href={capabilitiesUrl} className="btn">View Capabilities</a>
						)
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default WhySection;
